import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import {
  storeData,
  updateData,
} from '~/store/modules/modeloEquipamento/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const options = useMemo(
    () => [
      { label: 'Ativo', value: 'S' },
      { label: 'Inativo', value: 'N' },
    ],
    []
  );

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.modeloEquipamento
  );

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        mode_descricao: Yup.string()
          .typeError('Campo obrigatório')
          .required('Campo obrigatório'),
        mode_vazao_maxima: Yup.string()
          .typeError('Campo obrigatório')
          .required('Campo obrigatório'),
        mode_st_reg: Yup.string()
          .typeError('Campo obrigatório')
          .required('Campo obrigatório'),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input name="mode_descricao" label="Descrição" />

          <Input
            name="mode_vazao_maxima"
            label="Vazão Máxima (L/min)"
            type="number"
          />

          <Select name="mode_st_reg" label="Status" options={options} />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
